import PT from 'prop-types';
import React from 'react';

import { TruncateText } from '~/eds/src/components/Text/subcomponents/TruncateText';
import { Text } from '~/eds/src/components/Text/Text';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Icon from '~/ui/components/Icon/Icon';
import { downloadFile, getFileIcon } from '~/utils/files';

function FileLabel({
  enableDownload = false,
  file,
  hasBackground = false,
  shouldTruncate = false,
  onRemove,
}) {
  const intl = useIntl();
  const TextComponent = shouldTruncate ? TruncateText : Text;
  return (
    <FlexLayout
      alignItems="center"
      bg={hasBackground ? 'gray-300' : undefined}
      px={hasBackground ? 3 : undefined}
      py={hasBackground ? 2 : undefined}
      space={3}
      sx={{
        borderRadius: 'm',
        maxWidth: 'fit-content',
      }}
      onClick={enableDownload ? () => downloadFile(file) : undefined}
    >
      <Icon color="gray-600" icon={getFileIcon(file)} size="s" />
      <TextComponent variant="body-medium">
        {file.name ||
          intl.formatMessage({
            id: 'FileLabel.defaultFileName',
            defaultMessage: 'file',
            description: 'Default text when file name is not available',
          })}
      </TextComponent>

      {onRemove && (
        <Icon
          color="gray-500"
          icon="close"
          size="s"
          title={intl.formatMessage({
            id: 'FileLabel.removeFile',
            defaultMessage: 'Remove file',
            description: 'Tooltip text for remove file button',
          })}
          onClick={() => onRemove(file)}
        />
      )}
    </FlexLayout>
  );
}

FileLabel.propTypes = {
  /** Enable downloading the file */
  enableDownload: PT.bool,
  /** A `File`-like object */
  file: PT.object.isRequired,
  /** Decide if a background should be rendered */
  hasBackground: PT.bool,
  /** Truncate file text if true */
  shouldTruncate: PT.bool,
  /** Remove callback.  When provided, renders a close icon */
  onRemove: PT.func,
};

export default FileLabel;
